import { render } from "./PurchaseDialog.vue?vue&type=template&id=c1e725be&scoped=true"
import script from "./PurchaseDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseDialog.vue?vue&type=script&lang=js"

import "./PurchaseDialog.vue?vue&type=style&index=0&id=c1e725be&scoped=true&lang=css"

import exportComponent from "F:\\yiban\\WebProject\\yimeng-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e725be"]])

export default __exports__